import { LucideInfo } from 'lucide-react'
import { useState } from 'react'
import { aGoogleMapSimplifiedMode, aUser, useAtomValue } from '~/atoms'
import { Popover } from '~/components/ui'
import { cn } from '~/utils'

const SIMPLIFIED_MODE_MESSAGE =
  'Your browser or device has limited graphics support, so this map is running in a simplified mode.'

export function MapSimplifiedModeWarning({
  className,
}: {
  className?: string
}) {
  const isSimplifiedMode = useAtomValue(aGoogleMapSimplifiedMode)
  const user = useAtomValue(aUser)
  const [isOpen, setIsOpen] = useState(false)

  if (!isSimplifiedMode) return null

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <div
        className={cn(
          'absolute bottom-6 z-50 hidden sm:block',
          user ? 'right-[136px]' : 'right-32',
          className
        )}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}>
        <Popover.Trigger asChild>
          <button
            aria-label={SIMPLIFIED_MODE_MESSAGE}
            className="flex h-8 items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 text-xs font-medium text-amber-900 shadow-md transition-colors hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
            type="button"
            onBlur={() => setIsOpen(false)}
            onClick={() => setIsOpen((value) => !value)}
            onFocus={() => setIsOpen(true)}>
            <LucideInfo className="h-3.5 w-3.5" />
            Graphics
          </button>
        </Popover.Trigger>
      </div>
      <Popover.Content
        align="end"
        className="w-72 border-amber-200 bg-amber-50 p-3 text-sm leading-snug text-amber-950"
        side="top"
        sideOffset={10}>
        {SIMPLIFIED_MODE_MESSAGE}
      </Popover.Content>
    </Popover>
  )
}
